import bbbbSsctCakeLpFarmingPool from "../abis/development/bbbbSsct/pools/bbbbSsct";

const host = "https://bscscan.com/address";
const swapHost = "https://pancakeswap.finance/add";
const pairHost = "https://pancakeswap.info/pool";

export default [
  {
    title: "BBBB/SSCT",
    temperature: 65,
    type: "ssct",
    contractAddress: "0xaA66B1E51615336a78F18CA81A10D8a757358F8c",
    minApr: 159,
    abi: bbbbSsctCakeLpFarmingPool.abi,
    url: `${host}/0xaA66B1E51615336a78F18CA81A10D8a757358F8c`,
    swapUrl: `${swapHost}/BNB/0x0Af80145c7E50e5973dA3A5A174BF83A4ef94590`,
    pairUrl: `${pairHost}/0x55240e3f3e0746748bf8864e19b0ff4aaf717a4b`,
  },
];
